import script from "./Partners.vue?vue&type=script&setup=true&lang=js"
export * from "./Partners.vue?vue&type=script&setup=true&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=23cdf7d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23cdf7d6"]])

export default __exports__